import LightModeGif from "./dashboard-gifs/cs-manual-transaction-light.gif";

interface Props {}
export function ManualTransactionGuide(props: React.PropsWithChildren<Props>) {
  return <img className="guide-gif" src={LightModeGif} alt="loading..." />;
}
